// extracted by mini-css-extract-plugin
module.exports = {"FocusSpace":"Todos_FocusSpace__1jvZP","cardsTree":"Todos_cardsTree__18cFy"};